module.exports = __webpack_public_path__ + "static/image/sustainability/video.ver2_0_2.jpg?b53dcaa5";